<template>
    <div class="codics-pdf-body" id="pdfIframe" ref="pdfBody">
        <div class="codics-pdf-top-bar">
            <i v-show="false" class="iconfont codics-pdf-bottom-pag" @click="menuClick" style="float: left !important;"
                title="更多功能">&#xe866;</i>
            <el-image class="codics-pdf-top-logo" src="/img/logo.webp"
                fit="fill"></el-image>
            <i class="iconfont codics-pdf-bottom-pag" @click="mp3Play" style="float: left !important;" title="背景音乐"
                v-html="audioState ? '&#xe666;' : '&#xe665;'"></i>
            <i v-show="isMobile" class="iconfont codics-pdf-bottom-pag codics-pdf-bottom-pag-menu"
                @click="mobileBookmarkOpen = !mobileBookmarkOpen" title="书签">
                <svg viewBox="0 0 1024 1024" width="15" height="15" fill="currentColor"
                    style="position: relative;float: left;top: 12px;">
                    <path
                        d="M832 64H192c-35.3 0-64 28.7-64 64v832l352-224 352 224V128c0-35.3-28.7-64-64-64z" />
                </svg>
                <div
                    style="font-size: 13px;font-weight: 500;position: relative;float: right;margin-left: 5px;top: 1px;">
                    书签</div>
            </i>
            <i class="iconfont codics-pdf-bottom-pag iconfont codics-pdf-bottom-pag-menu" @click="dirClick"
                title="画册目录">&#xe715; <div
                    style="font-size: 13px;font-weight: 500;position: relative;float: right;margin-left: 5px;top: 1px;">
                    目录</div></i>
        </div>
        <transition name="editorloading">
            <div id="pdfPreviewLoading" class="codics-pdf-builder-editor-loading-box">
                <img class="codics-pdf-builder-editor-loading-view" src="/img/logo.png" alt="Loading..." />
                <el-progress class="codics-pdf-builder-editor-loading-progress" :stroke-width="6"
                    :percentage="nowProgress" :show-text="false" color="#555" define-back-color="#CCC"></el-progress>
                <div class="codics-pdf-builder-editor-loading-tip" v-html="nowTip"></div>
            </div>
        </transition>
        <div class="codics-pdf-bottom-bar">
            <el-avatar class="codics-pdf-bottom-himg" :size="30"
                :src="(pdfInfos?.account?.himg == '' || pdfInfos?.account?.himg == null) ? 'https://cdn.bosscaigou.com/PDF%E8%BD%AC%E7%94%BB%E5%86%8C/img/yasuo_1730cf82623a8ecb66abb090a178380.webp' : ('https://cdn.bosscaigou.com/' + pdfInfos?.account?.himg)"></el-avatar>
            <div class="codics-pdf-bottom-nick">{{ pdfInfos?.account?.nickname }}</div>
            <i class="iconfont codics-pdf-bottom-pag" @click="showPagBar" title="页面跳转">&#xe76d;</i>
            <!-- <i class="iconfont codics-pdf-bottom-pag" @click="showPagBar" title="计时翻页">&#xe6bb;</i> -->
            <!-- <i class="iconfont codics-pdf-bottom-pag codics-pdf-bottom-qrcode" style="font-size: 16px;"
                title="扫码浏览">&#xe608;
                <el-image class="codics-pdf-bottom-qrimg" :src="qrImg" fit="fill"></el-image>
            </i> -->
        </div>
        <!-- 移动端书签下拉面板(从顶部下拉) -->
        <transition name="mobilebookmark">
            <div v-show="isMobile && mobileBookmarkOpen" class="codics-pdf-mobile-bookmark">
                <div class="codics-pdf-bookmark-title">BookMark <i class="codics-pdf-bookmark-close"
                        @click="mobileBookmarkOpen = false" title="关闭">×</i></div>
                <div v-if="pdfInfos.list && pdfInfos.list.length > 0" class="codics-pdf-bookmark-list">
                    <div class="codics-pdf-bookmark-item" :class="{ 'active': activeTag == item.id }"
                        v-for="item in pdfInfos.list" :key="item.id" @click="goToTagPage(item)">
                        <i class="codics-pdf-bookmark-bullet"></i>
                        <div class="codics-pdf-bookmark-tag">{{ item.tag }}</div>
                        <div class="codics-pdf-bookmark-pge">第{{ item.pge }}页</div>
                    </div>
                </div>
                <div v-else class="codics-pdf-bookmark-empty">暂无书签</div>
            </div>
        </transition>
        <div v-show="isMobile && mobileBookmarkOpen" class="codics-pdf-mobile-bookmark-zz"
            @click="mobileBookmarkOpen = false"></div>
        <div v-show="menuState" @click="menuClick" class="codics-pdf-menu-zz"></div>
        <div v-show="!isMobile && bookState && pdfInfos.list && pdfInfos.list.length > 0" class="codics-pdf-bookmark"
            ref="bookmarkEl">
            <div class="codics-pdf-bookmark-toggle" @click="bookmarkOpen = !bookmarkOpen" title="BookMark">
                <!-- <i class="codics-pdf-bookmark-dot"></i> -->
                <div class="codics-pdf-bookmark-toggle-txt">BookMark</div>
                <!-- <i class="codics-pdf-bookmark-dot"></i> -->
            </div>
            <div v-show="bookmarkOpen" class="codics-pdf-bookmark-panel">
                <div class="codics-pdf-bookmark-title">BookMark <i class="codics-pdf-bookmark-close"
                        @click="bookmarkOpen = false" title="关闭">×</i></div>
                <div class="codics-pdf-bookmark-list">
                    <div class="codics-pdf-bookmark-item" :class="{ 'active': activeTag == item.id }"
                        v-for="item in pdfInfos.list" :key="item.id" @click="goToTagPage(item)">
                        <i class="codics-pdf-bookmark-bullet"></i>
                        <div class="codics-pdf-bookmark-tag">{{ item.tag }}</div>
                        <div class="codics-pdf-bookmark-pge">第{{ item.pge }}页</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VConsole from 'vconsole';
// import MyLoading from '@/components/MyLoading';
// import { doThat } from '@/utils/config';
import { sha1, getImageSize, loadJs } from '@/utils/myutils';
import QRCode from 'qrcode';
import { wxToken, pdfInfo } from '@/api';
export default {
    data() {
        return {
            audioState: false,
            loadState: false,
            loadProgress: 0,
            nowTip: '请耐心等待，正在加载中...',
            nowProgress: 0,
            totalPages: 0,
            nowPages: 0,
            scaleNum: 2,
            pdfData: [],
            pdfInfos: {},
            qrImg: '',
            menuState: false,
            wx: null,
            wxState: false,
            bookState: false,
            bookmarkOpen: false,
            mobileBookmarkOpen: false,
            activeTag: -1,
            bookmarkObserver: null,
            bookmarkRaf: null,
            bookmarkRectCache: null,
            bookmarkResizeObserver: null,
            bookReadyTimer: null,
            isMobile: window.innerWidth < 768,
            title: 'CNHONOR CATALOG-在线翻页阅读',
            desc: 'CNHONOR CATALOG：在线翻页阅读，畅享书籍魅力，随时随地，沉浸阅读',
            imgUrl: 'https://cdn.bosscaigou.com/PDF%E8%BD%AC%E7%94%BB%E5%86%8C/img/yasuo_1730cf82623a8ecb66abb090a178380.webp'
        }
    },
    mounted() {
        // const vConsole = new VConsole();
        // this.wxShare();
        import('@/../public/js/pdf.mjs');
        import('@/../public/js/pdf.worker.mjs');
        import('@/../public/js/FileSaver.js');
        import('@/../public/js/jszip.min.js');
        // if (!window.pdfWidth) {
        //     doThat(this);
        // }

        this.pdfInfoFuc();

        this.watchBookLoaded();

        this.watchBookReady();

        window.addEventListener('resize', this.handleResize);

        window.pdfNowPage = this.$route.query.p;
        this.creatQrCode(window.location.href);
        // document.getElementById('targetButton').click();

    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
        if (this.bookReadyTimer) {
            clearTimeout(this.bookReadyTimer);
            this.bookReadyTimer = null;
        }
        this.hidePreviewLoading();
        if (this.bookmarkRaf) {
            cancelAnimationFrame(this.bookmarkRaf);
            this.bookmarkRaf = null;
        }
        if (this.bookmarkResizeObserver) {
            this.bookmarkResizeObserver.disconnect();
            this.bookmarkResizeObserver = null;
        }
        if (this.bookmarkObserver) {
            this.bookmarkObserver.disconnect();
        }
        if (this.$route.path.indexOf('/book/show/') == -1) {
            let elements = document.getElementsByClassName("pdf-view-yichu");
            while (elements.length > 0) {
                elements[0].parentNode.removeChild(elements[0]);
            }
            let baoCuo = document.getElementById("webpack-dev-server-client-overlay");
            baoCuo.parentNode.removeChild(baoCuo);
        }
    },
    methods: {
        async pdfInfoFuc() {
            this.loadState = true;
            this.loadProgress = 20;
            this.nowProgress = 20;
            this.nowTip = '请耐心等待，正在加载中...';
            let data = await pdfInfo(this.$route.params.id, {});
            if (data.data?.mp3 != null && data.data?.mp3?.state == 0) {

                this.audio = new Audio('https://cdn.bosscaigou.com/' + data.data?.mp3?.url);

                this.audio.loop = data.data?.mp3?.lop == 0; // 设置音乐循环播放

            }
            this.loadProgress = 50;
            this.nowProgress = 50;
            this.pdfInfos = data.data;
            window.pdfName = data.data?.name || '';
            document.title = data.data?.name || '';
            let pdfDa = data.data.url.split(',');
            pdfDa = pdfDa.map(item => "https://cdn.bosscaigou.com/" + item);
            this.wxShare();
            if (data.code == 200) {
                await getImageSize(pdfDa[0], (t) => {

                    this.loadProgress = 75;

                    this.nowProgress = 75;

                    if (t) {

                        window.pdfWidth = t.width;

                        window.pdfHeight = t.height;

                        window.pdfData = pdfDa;

                    }

                    this.loadProgress = 100;

                    this.nowProgress = 100;

                    document.head.innerHTML += `<link rel="stylesheet" class='pdf-view-yichu' href="https://cdn.bosscaigou.com/PDF%E8%BD%AC%E7%94%BB%E5%86%8C/css/style.css" />
                <link rel="stylesheet" class='pdf-view-yichu' href="https://cdn.bosscaigou.com/PDF%E8%BD%AC%E7%94%BB%E5%86%8C/css/player.css" />
                <link rel="stylesheet" class='pdf-view-yichu' href="https://cdn.bosscaigou.com/PDF%E8%BD%AC%E7%94%BB%E5%86%8C/css/phoneTemplate.css" />
                <link rel="stylesheet" class='pdf-view-yichu' href="https://cdn.bosscaigou.com/PDF%E8%BD%AC%E7%94%BB%E5%86%8C/css/template.css" />`;

                    // loadJs('./js/jquery-1.9.1.min.js');
                    // window.$ = window.jQuery = $;
                    loadJs('../../js/config.js');
                    loadJs('../../js/bookmark_config.js');
                    loadJs('../../js/LoadingJS.js');
                    loadJs('../../js/main.js');
                    loadJs('var sendvisitinfo = function (type, page) { };', true);

                });

            } else {
                this.hidePreviewLoading();
                this.$message.error(data.message);
            }
            this.loadState = false;
        },
        // 兜底隐藏加载遮罩(接口失败等异常场景)
        hidePreviewLoading() {
            var el = document.getElementById('pdfPreviewLoading');
            if (el) el.style.display = "none";
        },
        async wxShare() {

            if (this.wx == null) {

                this.wx = require("weixin-js-sdk");

                const _this = this;

                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });

                let data = await wxToken();

                loading.close();

                if (data.code == 200) {

                    let jsapi_ticket = data.data;

                    let timestamp = new Date().getTime();

                    let url = window.location.href;

                    let nonceStr = 'Book_zxhcfx';

                    let signature = `jsapi_ticket=${jsapi_ticket}&noncestr=${nonceStr}&timestamp=${timestamp}&url=${url}`;

                    this.wx.config({
                        debug: false, // 开启调试模式,调用的所有 api 的返回值会在客户端 alert 出来，若要查看传入的参数，可以在 pc 端打开，参数信息会通过 log 打出，仅在 pc 端时才会打印。
                        appId: 'wx4231c17aa76472b1', // 必填，公众号的唯一标识
                        timestamp: timestamp, // 必填，生成签名的时间戳
                        nonceStr: nonceStr, // 必填，生成签名的随机串
                        signature: sha1(signature),// 必填，签名
                        jsApiList: [
                            'updateAppMessageShareData',
                            'onMenuShareAppMessage',
                            'updateTimelineShareData',
                            'onMenuShareTimeline'
                        ] // 必填，需要使用的 JS 接口列表
                    });

                    _this.wx.ready(function () {   //需在用户可能点击分享按钮前就先调用

                        console.log("准备好了", _this.pdfInfos?.himg)

                        _this.wx.updateAppMessageShareData({
                            title: document.title || _this.title, // 分享标题
                            desc: _this.pdfInfos?.detail, // 分享描述
                            link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
                            imgUrl: _this.pdfInfos?.himg == '' ? _this.imgUrl : ('https://cdn.bosscaigou.com/' + _this.pdfInfos?.himg), // 分享图标
                            // success: function () {

                            // }
                        });

                        // 分享朋友圈
                        _this.wx.updateTimelineShareData({
                            title: document.title || _this.title, // 分享标题
                            link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
                            imgUrl: _this.pdfInfos?.himg == '' ? _this.imgUrl : ('https://cdn.bosscaigou.com/' + _this.pdfInfos?.himg), // 分享图标
                            success: function () {
                                // 设置成功
                            }
                        });

                    });

                } else {

                    this.$message.error(data.message);

                }

            } else {

                this.wx.ready(function () {   //需在用户可能点击分享按钮前就先调用

                    _this.wx.updateAppMessageShareData({
                        title: document.title || _this.title, // 分享标题
                        desc: _this.pdfInfos?.detail, // 分享描述
                        link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
                        imgUrl: _this.pdfInfos?.himg == '' ? _this.imgUrl : ('https://cdn.bosscaigou.com/' + _this.pdfInfos?.himg), // 分享图标
                        // success: function () {

                        // }
                    });

                    // 分享朋友圈
                    _this.wx.updateTimelineShareData({
                        title: document.title || _this.title, // 分享标题
                        link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
                        imgUrl: _this.pdfInfos?.himg == '' ? _this.imgUrl : ('https://cdn.bosscaigou.com/' + _this.pdfInfos?.himg), // 分享图标
                        success: function () {
                            // 设置成功
                        }
                    });

                });

            }


            //分享给朋友

        },
        async creatQrCode(QRlink) {   // QRlink是二维码的内容
            var _this = this;
            let opts = {
                errorCorrectionLevel: "L",//容错级别
                type: "image/png",//生成的二维码类型
                quality: 0.3,//二维码质量
                margin: 1,//二维码留白边距
                width: 100,//宽
                height: 100,//高
                text: QRlink,//二维码内容
                color: {
                    dark: "#000",//前景色
                    light: "#fff"//背景色
                }
            };
            await QRCode.toDataURL(QRlink, opts, (err, url) => {
                if (err) throw err
                //将生成的二维码路径复制给data的QRImgUrl
                // console.log(url)
                _this.qrImg = url;
            })
        },
        showPagBar() {
            document.getElementById('menu').style.bottom = document.getElementById('menu').style.bottom == '-80px' ? '80px' : '-80px';
            // document.getElementById('contentBox').style.bottom = document.getElementById('menu').style.bottom == '-80px' ? '40px' : '-80px';
        },
        menuClick() {
            this.menuState = !this.menuState;
            $('#btnMore').trigger(_event._end);
        },
        dirClick() {
            $('#btnThumb').trigger(_event._end);
        },
        mp3Play() {
            if (!this.audio) {
                this.$message.error("未设置背景音乐！");
                return;
            }
            this.audioState = this.audio.paused;
            if (this.audio?.paused) {
                this.audio.play();
            } else {
                this.audio.pause();
            }
        },
        // 监听画册渲染容器 #flipBook 出现，视为画册加载成功，随后显示BookMark栏（移动端不加载BookMark功能）
        watchBookLoaded() {
            if (this.isMobile) return; // 移动端直接跳过，不加载BookMark功能
            const check = () => {
                if (document.getElementById('flipBook')) {
                    this.bookState = true;
                    if (this.bookmarkObserver) {
                        this.bookmarkObserver.disconnect();
                        this.bookmarkObserver = null;
                    }
                    // 画册初始化有延迟，先定位一次，随后持续跟踪位置/尺寸变化
                    this.$nextTick(() => {
                        this.positionBookmark();
                        this.startBookmarkWatch();
                    });
                }
            };
            check();
            if (!this.bookState) {
                this.bookmarkObserver = new MutationObserver(check);
                this.bookmarkObserver.observe(document.body, { childList: true, subtree: true });
            }
        },
        // 兜底隐藏加载遮罩：监听 #flipBook 出现（画册渲染完成）即隐藏；另设超时兜底，防止加载失败/JS加载异常导致遮罩常驻
        watchBookReady() {
            const hide = () => {
                this.hidePreviewLoading();
                if (this.bookReadyTimer) {
                    clearTimeout(this.bookReadyTimer);
                    this.bookReadyTimer = null;
                }
            };
            const check = () => {
                if (document.getElementById('flipBook')) {
                    hide();
                    return true;
                }
                return false;
            };
            // 立即检测一次
            if (check()) return;
            // MutationObserver 监听 flipBook 出现
            const observer = new MutationObserver(() => {
                if (check()) observer.disconnect();
            });
            observer.observe(document.body, { childList: true, subtree: true });
            // 超时兜底（20秒后强制隐藏），防止 main.js 异常导致遮罩常驻
            this.bookReadyTimer = setTimeout(hide, 20000);
        },
        // 持续跟踪 #flipBook 的位置与尺寸变化，实时更新BookMark栏位置
        startBookmarkWatch() {
            const book = document.getElementById('flipBook');
            if (!book || this.bookmarkRaf) return;
            // 尺寸变化监听（缩放、模式切换等改变 flipBook 宽高时触发）
            if (typeof ResizeObserver !== 'undefined' && !this.bookmarkResizeObserver) {
                this.bookmarkResizeObserver = new ResizeObserver(() => this.positionBookmark());
                this.bookmarkResizeObserver.observe(book);
            }
            // 每帧轮询：位置（top/left）变化时更新BookMark栏位置
            const loop = () => {
                const rect = book.getBoundingClientRect();
                const c = this.bookmarkRectCache;
                if (!c ||
                    Math.abs(rect.top - c.top) > 0.5 ||
                    Math.abs(rect.left - c.left) > 0.5 ||
                    Math.abs(rect.width - c.width) > 0.5 ||
                    Math.abs(rect.height - c.height) > 0.5) {
                    this.bookmarkRectCache = {
                        top: rect.top,
                        left: rect.left,
                        width: rect.width,
                        height: rect.height
                    };
                    this.positionBookmark();
                }
                this.bookmarkRaf = requestAnimationFrame(loop);
            };
            loop();
        },
        // 窗口尺寸变化：更新移动端状态，必要时重新启用BookMark功能
        handleResize() {
            const prev = this.isMobile;
            this.isMobile = window.innerWidth < 768;
            if (prev && !this.isMobile && !this.bookState) {
                this.watchBookLoaded(); // 从移动端切到 PC 端且BookMark未加载时，重新启用
            }
            if (!this.isMobile) {
                this.positionBookmark();
            }
        },
        // 将BookMark栏定位到 #flipBook 外侧右方30px、顶部与画册顶部对齐（相对 .codics-pdf-body 绝对定位）
        positionBookmark() {
            const book = document.getElementById('flipBook');
            const bookmark = this.$refs.bookmarkEl;
            const container = this.$refs.pdfBody;
            if (!book || !bookmark || !container) return;
            const rect = book.getBoundingClientRect();
            if (rect.width == 0 || rect.height == 0) return; // 画册尚未渲染完成
            const cRect = container.getBoundingClientRect();
            bookmark.style.top = (rect.top - cRect.top) + 'px';
            bookmark.style.left = (rect.right - cRect.left + 25) + 'px';
        },
        // 点击BookMark跳转到指定页
        goToTagPage(item) {
            this.activeTag = item.id;
            this.mobileBookmarkOpen = false;
            if (typeof gotoPageFun === 'function') {
                gotoPageFun(parseInt(item.pge));
            } else {
                this.$message.error("画册尚未加载完成，请稍后再试！");
            }
        }
    },
    watch: {
        bookmarkOpen() {
            this.$nextTick(() => {
                this.positionBookmark();
            });
        }
    }
}
</script>

<style>
.codics-pdf-body {
    height: 100%;
    width: 100%;
    position: relative;
    float: left;
    overflow: hidden;
    padding: 0;
    margin: 0;
}

.codics-pdf-top-bar {
    height: 40px !important;
    width: 100% !important;
    position: absolute !important;
    top: 0;
    background: #E8E8E8;
    z-index: 1111;
    box-shadow: rgba(40, 0, 0, 0.1) 0px 0px 2px !important;
    border-bottom: 1px solid #EEE !important;
}

.codics-pdf-top-logo {
    height: 100%;
    width: 100px;
    position: relative;
    float: left;
    top: 50%;
    transform: translateY(-50%);
    margin-left: 15px;
}

.codics-pdf-view {
    height: 100%;
    width: 100%;
    position: relative;
    float: left;
}

/* #pbTopBar */
#pbToolBar {
    display: none !important;
}

.codics-pdf-bottom-bar {
    height: 40px !important;
    width: 100% !important;
    position: absolute !important;
    bottom: 0 !important;
    background: #E8E8E8;
    /* display: none; */
    box-shadow: rgba(40, 0, 0, 0.1) 0px 0px 5px;
    border-top: 1px solid #EEE;
    z-index: 1111;
}

/* 用户头像 */
.codics-pdf-bottom-himg {
    position: relative;
    float: left;
    top: 5px;
    left: 5px;
}

.codics-pdf-bottom-nick {
    height: 100%;
    width: fit-content;
    position: relative;
    float: left;
    line-height: 40px;
    text-align: center;
    font-size: 14px;
    color: #333;
    font-weight: 600;
    margin-left: 15px;
}

.codics-pdf-bottom-pag {
    height: 100%;
    width: 40px;
    position: relative;
    float: right;
    line-height: 40px;
    text-align: center;
    font-size: 18px;
    color: #333;
    user-select: none;
    cursor: pointer;
}

.codics-pdf-bottom-qrimg {
    height: 100px;
    width: 100px;
    position: absolute;
    top: -143px;
    right: 0;
    opacity: 0;
    transition: .4s;
    background: #333;
}

.codics-pdf-bottom-qrcode:hover .codics-pdf-bottom-qrimg {
    opacity: 1;
}

#menu {
    transition: .4s;
}

.pdf-view-yichu {
    padding-top: 40px;
    background-color: #E8E8E8 !important;
}

.codics-pdf-menu-zz {
    height: 100%;
    width: calc(100% - 330px);
    position: absolute !important;
    top: 0 !important;
    right: 0 !important;
    z-index: 111111;
}

.menuTitle {
    background-color: unset !important;
    border-top: unset !important;
    border-bottom: 1px solid #DDD !important;
}

.menuTitleCaption {
    color: #333 !important;
}

.menuTitle+div {
    background-color: unset !important;
}

.menuTitle+div div p label {
    color: #333 !important;
}

.codics-pdf-bottom-pag-menu {
    width: fit-content !important;
    padding: 0 15px 0 15px;
}

/* 右侧纵向BookMark栏（位置由 JS 定位到 #flipBook 外侧右方30px，方案D 悬浮胶囊 · 黑白配色） */
.codics-pdf-bookmark {
    height: fit-content;
    max-height: calc(100% - 120px);
    position: absolute !important;
    z-index: 1200;
    display: flex;
    flex-direction: row;
    align-items: stretch;
}

/* 胶囊BookMark按钮（纯白配色 · 无边框） */
.codics-pdf-bookmark-toggle {
    width: 42px;
    position: relative;
    float: left;
    background: #FFFFFF;
    border-radius: 24px;
    cursor: pointer;
    user-select: none;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 12px 0;
    color: #111111;
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.1);
    transition: all .2s;
}

.codics-pdf-bookmark-toggle:hover {
    background: #F5F5F5;
    transform: translateX(-3px);
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.16);
}

.codics-pdf-bookmark-dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #111111;
    display: block;
}

.codics-pdf-bookmark-toggle-txt {
    writing-mode: vertical-rl;
    margin: 9px 0;
    font-size: 12.5px;
    font-weight: 700;
    letter-spacing: 3px;
}

/* 弹出BookMark卡片（纯白配色 · 无边框） */
.codics-pdf-bookmark-panel {
    width: 200px;
    margin-left: 10px;
    background: #FFFFFF;
    border-radius: 16px;
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.14);
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.codics-pdf-bookmark-title {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 11px 14px;
    background: #FFFFFF;
    color: #111111;
    font-size: 13.5px;
    font-weight: 700;
    letter-spacing: 3px;
    border-bottom: 1px solid #EEEEEE;
}

.codics-pdf-bookmark-close {
    width: 21px;
    height: 21px;
    border-radius: 50%;
    background: #F0F0F0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-style: normal;
    cursor: pointer;
    color: #111111;
    line-height: 1;
    transition: all .18s;
}

.codics-pdf-bookmark-close:hover {
    background: #111111;
    color: #FFFFFF;
}

.codics-pdf-bookmark-list {
    flex: 1;
    overflow-y: auto;
    padding: 9px;
    max-height: 45vh;
}

.codics-pdf-bookmark-item {
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 9px;
    padding: 8px 10px;
    border-radius: 11px;
    margin-bottom: 4px;
    transition: all .18s;
}

.codics-pdf-bookmark-item:hover {
    background: #F5F5F5;
}

.codics-pdf-bookmark-item.active {
    background: #EEEEEE;
}

.codics-pdf-bookmark-bullet {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #111111;
    flex-shrink: 0;
}

.codics-pdf-bookmark-item.active .codics-pdf-bookmark-bullet {
    background: #111111;
    box-shadow: 0 0 0 2px rgba(17, 17, 17, 0.18);
}

.codics-pdf-bookmark-tag {
    flex: 1;
    font-size: 12.5px;
    font-weight: 600;
    color: #333333;
    line-height: 1.35;
    word-break: break-all;
}

.codics-pdf-bookmark-pge {
    font-size: 11px;
    color: #999999;
}

.codics-pdf-bookmark-item.active .codics-pdf-bookmark-tag {
    color: #111111;
    font-weight: 700;
}

.codics-pdf-bookmark-item.active .codics-pdf-bookmark-pge {
    color: #666666;
}

.codics-pdf-bookmark-list::-webkit-scrollbar {
    width: 4px;
}

.codics-pdf-bookmark-list::-webkit-scrollbar-thumb {
    background: #DDDDDD;
    border-radius: 2px;
}

/* ===== 加载遮罩(1:1 复刻 A4 画册编辑器) ===== */
.codics-pdf-builder-editor-loading-box {
    height: 100%;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    box-sizing: border-box;
    background: #F3F3F5;
    z-index: 99999;
    pointer-events: all;
}

.codics-pdf-builder-editor-loading-view {
    width: 220px !important;
    height: auto !important;
    position: absolute !important;
    margin: auto !important;
    top: -130px !important;
    bottom: 0 !important;
    left: 0 !important;
    right: 0 !important;
    object-fit: contain;
    user-select: none;
}

.codics-pdf-builder-editor-loading-progress {
    height: fit-content !important;
    width: 180px !important;
    position: absolute !important;
    margin: auto !important;
    top: 0 !important;
    bottom: 0 !important;
    left: 0 !important;
    right: 0 !important;
}

.codics-pdf-builder-editor-loading-tip {
    height: 50px;
    width: 100%;
    position: absolute;
    margin: auto;
    top: 120px;
    bottom: 0;
    left: 0;
    right: 0;
    text-align: center;
    line-height: 50px;
    font-size: 13px;
    color: #333;
    user-select: none;
    font-weight: bolder;
}

/* 定义进入和离开的过渡效果 */
.editorloading-enter-active,
.editorloading-leave-active {
    transition: .3s;
}

.editorloading-enter,
.editorloading-leave-to {
    opacity: 0;
}

/* ===== 移动端书签下拉面板(从顶部下拉) ===== */
.codics-pdf-mobile-bookmark {
    width: 100%;
    max-height: 60vh;
    position: fixed;
    top: 40px;
    left: 0;
    z-index: 1100;
    background: #FFFFFF;
    border-radius: 0 0 14px 14px;
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.14);
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.codics-pdf-mobile-bookmark .codics-pdf-bookmark-list {
    max-height: 55vh;
}

/* 移动端下拉遮罩 */
.codics-pdf-mobile-bookmark-zz {
    height: 100%;
    width: 100%;
    position: fixed;
    top: 40px;
    left: 0;
    background: rgba(0, 0, 0, 0.35);
    z-index: 1090;
}

/* 从顶部下拉过渡动画 */
.mobilebookmark-enter-active,
.mobilebookmark-leave-active {
    transition: all .3s ease;
}

.mobilebookmark-enter,
.mobilebookmark-leave-to {
    transform: translateY(-30px);
    opacity: 0;
}

/* 移动端书签空状态 */
.codics-pdf-bookmark-empty {
    padding: 30px 0;
    text-align: center;
    font-size: 13px;
    color: #999;
    flex-shrink: 0;
}
</style>